import { round, subtract } from 'vend-number'

/**
 * Max cash/card the register can collect against account balance while
 * pay-balance payments (e.g. ACH) are still in transit.
 *
 * Headline owing stays the full account balance; this subtracts in-transit
 * so merchants cannot re-collect that portion (QM-9059).
 */
export const getMaxPayableAmount = (
  accountBalance: number,
  inTransitAmount: number
): number => {
  const balance = Number.isFinite(accountBalance) ? accountBalance : 0
  const inTransit = Number.isFinite(inTransitAmount) ? inTransitAmount : 0
  return Math.max(0, Number(round(subtract(balance, inTransit), 2)))
}
